var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikesmedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.24c-.23 0-.46-.03-.64-.1C5.49 15.16.94 11.67.94 6.52A4.75 4.75 0 0 1 9 3.14a4.66 4.66 0 0 1 3.33-1.38 4.75 4.75 0 0 1 4.73 4.76c0 5.16-4.55 8.64-7.41 9.62-.2.07-.42.1-.65.1ZM5.67 2.89a3.62 3.62 0 0 0-3.6 3.63c0 5.12 4.92 7.97 6.65 8.56.14.05.43.05.56 0 1.73-.59 6.67-3.43 6.67-8.56 0-2-1.63-3.63-3.61-3.63-1.14 0-2.2.53-2.88 1.45-.21.29-.7.29-.9 0A3.58 3.58 0 0 0 5.67 2.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikesmedium);
export default __webpack_public_path__ + "static/media/likes.medium.c49c06bb084af57753cd6073792dfc71.svg";
export { ForwardRef as ReactComponent };